<template>
  <div>
    <b-overlay :show="isConfirmNeeded" no-wrap>
      <template v-slot:overlay>
        <div
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3 border border-danger rounded"
        >
          <p>
            <strong id="form-confirm-label">Are you sure, You want to permantly delete this item ? </strong>
          </p>
          <div class=" mx-auto">
            <b-button variant="outline-danger" class="mr-3" @click="isDeletePopUp">Cancel</b-button>
            <b-button variant="outline-success" @click="onOK">OK</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <b-card style="margin:20px">
      <b-row>
        <b-col cols=2 style="width:300px;">
          <sidebar></sidebar>
        </b-col>
        
        <div class="mr-1" style="border:solid;width:1px"></div>
        <b-col cols="9">
          <div>
            <b-row>
              <b-col cols="4">
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Filter By"
                >
                  <b-form-select
                    @change="onFilterTypeChange()"
                    v-model="filterValue"
                    :options="optionsFilter"
                    class="m-md-2"
                  ></b-form-select>
                </b-form-group>
              </b-col>
      
              <b-col>
                <b-button to="/admin/add-user" variant="primary">Add New User  <b-icon class="ml-2" icon="person-plus" aria-hidden="true"></b-icon> </b-button>
              </b-col>
              <b-col cols="4">
                <b-form-input class="m-md-2" type="search" placeholder="Search"></b-form-input>
              </b-col>
            </b-row>

            <div class="ma-4" style="padding-bottom:20px"></div>
            <b-row >
              <b-col style="overflow-y:auto; height:450px">
              <table  class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">User Role</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in admins" :key="admin.uid">
                    <td>{{admin.name}}</td>
                    <td>{{admin.user}}</td>
                    <td>
                      <!-- { name: 'Page2', params: { id: 1234 } -->
                      <b-button @click="routeEdit(admin.uid)">Edit</b-button>
                      <span style="padding-left:20px"></span>
                      <b-button @click="isDeletePopUp()">Delete</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import sidebar from "../AdminSlidebar";

export default {
  name: "UserManagementMainWindow",
  components: {
    sidebar
  },
  methods: {
    onFilterTypeChange() {
      console.log(this.filterValue);
    },
    routeEdit(uid){
        this.$router.push({ name: 'AdminEdit', params: { id: uid } })

    },
    isDeletePopUp() {
      this.isConfirmNeeded = !this.isConfirmNeeded;
    }
  },
  data() {
    return {
      filterValue: "a",
      isConfirmNeeded: false,
      optionsFilter: [
        { value: "a", text: "User Role" },
        { value: "b", text: "Name" }
      ],
      admins: [
        {
          name: "Nishshanaka",
          user: "admin 123",
          uid: "wtUxBhEHmColGhk"
        },
        {
          name: "Ramesh",
          user: "admin 723",
          uid: "UCijPgjncwRwzje"
        },
        {
          name: "Chamara",
          user: "admin 887",
          uid: "VOjNgiNoBlPLRpv"
        },
        {
          name: "NishshanakaJ",
          user: "admin 123",
          uid: "bApHKXqxrPCkWGI"
        },
        {
          name: "Jayasinghe",
          user: "user 123",
          uid: "QFbKypGJGqmnIZz"
        },
         {
          name: "Nishshanaka",
          user: "admin 123",
          uid: "wtUxBhEHmColGhk"
        },
        {
          name: "Ramesh",
          user: "admin 723",
          uid: "UCijPgjncwRwzje"
        },
        {
          name: "Chamara",
          user: "admin 887",
          uid: "VOjNgiNoBlPLRpv"
        },
        {
          name: "NishshanakaJ",
          user: "admin 123",
          uid: "bApHKXqxrPCkWGI"
        },
        {
          name: "Jayasinghe",
          user: "user 123",
          uid: "QFbKypGJGqmnIZz"
        }
      ]
    };
  }
};
</script>

<style>
</style>